import { mapGetters } from "vuex";
import config from '@/config'
import pageheader from "../pageheader";
import utils from "../../utils/util";
import Vue from "vue";
import moment from "moment";

import telematicsService from "../../api/telematics.service";

import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
  load: {
    key: config.GOOGLE_MAPS_API,
    libraries: "places",
  },
});
export default {
  name: 'movement',
  components: { pageheader},
  props: [],
  data () {
    return {
      input:{},
      tab: 0,
      selectType:["Geolocations"],
      selected:"",
      center: {},
      currentPlace: null,
      markers: [],
      filterDialog: false,
      isApplyFilter: false,
      infowindow: false,
      infowindowdiv:false,
      mapColValue: "10",
      filterColValue: "",
      info_marker: null,
      infowindowpos: {},
      window_open: false,
      locationDetails: {},

    }
  },
  computed: {
    ...mapGetters(["roles"]),

  },
  filters: {
    formatDates: function (value) {
      if (value) {
        // const format = "MM/DD/YYYY";
        const format = "MMMM DD,YYYY hh:mm";

        return moment(value).format(format);
      }
    },
  },
  mounted () {
    this.input = utils.getInputContent("movement", this.roles);
    this.viewMapWithoutFilter();
    this.geolocate();
    this.readCities();
  },
  methods: {
 // load initial Google Maps with user's current location
 geolocate: function () {
  navigator.geolocation.getCurrentPosition((position) => {
    this.center = {
      lat: position.coords.latitude,
      lng: position.coords.longitude,
    };
    // this.markers.push(this.center);
    // console.log(this.markers)
    // this.infowindowpos = this.center;
  });
},
viewMapWithoutFilter() {
  this.filterColValue = "";
  this.mapColValue = "10";
  this.filterDialog = false;
},
viewMapWithFilter() {
  this.filterColValue = "4";
  this.mapColValue = "10";
},
// Open & Close Filters
openFilterDialog() {
  this.filterDialog = true;
  this.viewMapWithFilter();
},
closeFilterDialog() {
  this.filterDialog = false;
  this.viewMapWithoutFilter();
  this.selectedEquipment = "";
  this.selectedStatus = "";
  this.selectedJob = "";
  this.selectedZone = "";
  // this.selectedRentalStatus = "";
  // this.selectedGPSStatus = "";
  // this.selectedOtherFilters = "";
},
// Read cities or Lat/Lng from Api
async readCities() {
  this.isApplyFilter = true;
  this.infowindow = false;
  this.infowindowdiv = false;
  try {
    let mapResponse = await telematicsService.getEquipmentsList();
    if (mapResponse.isSuccess) {
      console.log(mapResponse);
      this.isApplyFilter = false;
      this.viewMapWithoutFilter();
      let locations = mapResponse.data.filter(
        (x) => x.lastLocation != null
      );
      this.markers = locations.slice(0, 100);
      this.center = this.markers[0].lastLocation;
      this.markers.forEach(function(row, index) {
        row.colorCheck = index % 2 == 0 ? "green-bg" : "blue-bg";
       
      });
    } else {
      this.isApplyFilter = false;
      this.viewMapWithoutFilter();
      this.markers = [];
    }
  } catch (err) {
    this.isApplyFilter = false;
    this.viewMapWithoutFilter();
    console.log(err);
  }
}
,
viewRentalDetails(){
  // this.dialog = true;
  // this.$router.push({name: "View Equipment Details", params:{details : item }});
  // this.$router.push({name: "View Contract Details"});
  this.$router.push({name: "View Rental Equipment Details"});

},
viewAssetDetails(){
  // this.dialog = true;
  // this.$router.push({name: "View Equipment Details", params:{details : item }});
  // this.$router.push({name: "View Contract Details"});
  this.$router.push({name: "View Customer Owned Equipment Details"});

},
// Open & close window when click on marker/pin removed code---
openWindow(item) {
  this.infowindow = true;
  this.locationDetails = item;
  // this.infowindowpos = item.lastLocation;
},
closeInfoWindow() {
  this.infowindow = false;
},
// Open & close window when click on marker/pin new
openWindowdiv(item) {

  this.infowindowdiv = true;
  this.locationDetails = item;
  // this.infowindowpos = item.lastLocation;
},
closeInfoWindowdiv() {
  this.infowindowdiv = false;
  this.tab =0;
},
  }
}

